/* eslint-disable react/prop-types */
import React from 'react';
import FontStyles from '../fonts/FontStyles';
import { GlobalStyle } from './styles/Layout.styled';

export default function Layout({ dir, children }) {
  return (
    <>
      <FontStyles />
      <GlobalStyle dir={dir} />
      {children}
    </>
  );
}
